import { lazy } from 'react';

const Text = lazy(() => import('./Text'));

export { Text };
